import { Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { useMetadataAtomValue } from "../metadataAtom.ts";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { ComplianceDetailsFields } from "./ComplianceDetailsFields";

export const HostDetailsController = () => {
    const {
        cmsData: {
            profile: { hostDetails, accountDetails, legalInformation },
        },
    } = useStaticDataAtomValue();
    const {
        experimentsAtom: { isConvergenceProfile },
    } = useMetadataAtomValue();

    return (
        <VStack gap="24">
            {isConvergenceProfile ? (
                <VStack gap="8">
                    <Typography variant="heading-default">{accountDetails}</Typography>
                    <Typography variant="body-s" textColor="base.subtle">
                        {legalInformation}
                    </Typography>
                </VStack>
            ) : (
                <Typography variant="heading-default">{hostDetails}</Typography>
            )}
            <ComplianceDetailsFields fieldPrefix="hostDetails" multiple={false} prefixDataElementName="host" />
        </VStack>
    );
};
